import { call, put, takeLeading } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import enrolCreate from 'api/enrols/Create'
import { IEnrolModel } from 'models/enrol.model'
import { EnrolState } from 'enum'
import getCourse from 'api/courses/Get'
import I18n from 'i18n'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import * as fromCourseActions from '../../actions/courses.action'
import * as fromActions from '../../actions/enrols.action'

async function createEnrol(data: IEnrolModel) {
  return await enrolCreate(data)
}

async function handleGetCourse(courseId: number) {
  return await getCourse(courseId)
}

function* enrolCreateEffectSaga(action: fromActions.EnrolCreateAction) {
  try {
    const {
      payload: { getCourse, enrol, isSynchronous, showToast = true },
    } = action

    const { data: getEnrol }: { data: any } = yield call(createEnrol, enrol)
    yield put(fromActions.Actions.enrolCreateSuccess(getEnrol))

    if (
      (getEnrol.stateAdmin === EnrolState.Approved && getCourse) ||
      isSynchronous
    ) {
      const courseData = yield call(handleGetCourse, getEnrol.courseId)
      yield put(fromCourseActions.Actions.getCourseSuccess(courseData))
    }

    if (getEnrol.stateAdmin === EnrolState.Approved) {
      yield put(push(`/courses/${getEnrol.courseId}/lessons`))
    } else {
      showToast && SuccessToast(I18n.t('courses.toasts.request'))
    }
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* enrolCreateWatcherSaga() {
  yield takeLeading(fromActions.ENROL_CREATE, enrolCreateEffectSaga)
}
